import {
  easypostFedexMfaValidateInvoiceInputSchema,
  easypostFedexMfaValidateInvoiceOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/easypost-fedex-mfa";

export const easypostFedexMfaValidateInvoice = {
  name: "easypostFedexMfaValidateInvoice" as const,
  input: easypostFedexMfaValidateInvoiceInputSchema,
  output: easypostFedexMfaValidateInvoiceOutputSchema,
};
